<app-upsell-card [htmlTitle]="htmlTitle" [question]="question" [slug]="slug">
  <ng-content></ng-content>
</app-upsell-card>
